<div id="malbicon">
    <!-- <img [src]="image" *ngIf="image" [style.width]="width" [style.height]="height" [style.fill]="fill" /> -->
    <div #imagefile [style.width]="width" [style.height]="height"></div>
</div> 